<template>
    <footer class="flex flex-row justify-evenly">
        <div class="footer-col">
            <h5>Giới thiệu</h5>
            <p>
                Cửa hàng chuyên cung cấp các loại mắt kính – gọng kính với mức giá phù hợp với tâm lý khách
                hàng và có tính cạnh tranh cao. HMK Eyewear luôn luôn mong muốn làm hài lòng tất cả khách hàng.
            </p>
        </div>

        <div class="footer-col">
            <h5>Giấy phép</h5>
            <p>Mã số đăng ký: 41Q8041389</p>
            <p>Ngày cấp: 05/10/2020</p>
            <p>Nơi cấp: Phòng Kinh tế UBND Quận Bình Thạnh</p>
        </div>

        <div class="footer-col">
            <h5>Liên hệ</h5>
            <p>Hotline: 1900 9368</p>
            <p>Email: website@hmkeyewear.com</p>
            <p>Địa chỉ: 142 Nguyễn Gia Trí, Phường Thạnh Mỹ Tây, TP. Hồ Chí Minh</p>
            <div class="flex items-center gap-1">
                <a href="https://facebook.com" target="_blank"><i class="fa-brands fa-facebook fa-2x"></i></a>
                <a href="https://tiktok.com" target="_blank"><i class="fa-brands fa-tiktok fa-2x"></i></a>
                <a href="https://instagram.com" target="_blank"><i class="fa-brands fa-instagram fa-2x"></i></a>
                <a href="https://telegram.com" target="_blank"><i class="fa-brands fa-telegram fa-2x"></i></a>
            </div>
        </div>

        <div class="footer-col">
            <h5>Góp ý</h5>
            <p>Chúng tôi luôn trân trọng và mong đợi nhận được mọi ý kiến đóng góp từ khách hàng để có thể nâng cấp trải
                nghiệm dịch vụ và sản phẩm tốt hơn nữa.</p>
            <button>ĐÓNG GÓP Ý KIẾN</button>
        </div>
    </footer>
</template>